import { render, staticRenderFns } from "./dragTable.vue?vue&type=template&id=c6d02ef8&scoped=true"
import script from "./dragTable.vue?vue&type=script&lang=js"
export * from "./dragTable.vue?vue&type=script&lang=js"
import style0 from "./dragTable.vue?vue&type=style&index=0&id=c6d02ef8&prod&lang=css"
import style1 from "./dragTable.vue?vue&type=style&index=1&id=c6d02ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d02ef8",
  null
  
)

export default component.exports